<odx-modal-header>
  <odx-area-header i18n="@@groupConfiguration.modal.addProducts.header">Produkte hinzufügen</odx-area-header>
</odx-modal-header>
<odx-modal-content>
  <h5 class="odx-title-5" i18n="@@groupConfiguration.modal.products">Verfügbare Produkte</h5>
  <app-group-configuration-table
    [group]="this.modalRef.data.group"
    [floorplan]="this.modalRef.data.floorplan"
    [project]="this.project"
    (selectedProductsChanged)="onSelectedProductsChanged($event)"
    [productsToDisplay]="productsToDisplay"
  ></app-group-configuration-table>
</odx-modal-content>
<odx-modal-footer>
  <button odxButton variant="secondary" i18n="@@groupConfiguration.modal.button.cancel" odxModalDismiss>Abbrechen</button>
  <button odxButton variant="primary" i18n="@@groupConfiguration.modal.button.confirm" (click)="onConfirm()">Bestätigen</button>
</odx-modal-footer>
